<template>
<div>
    <div class="container">
        <div class="space-100"></div>
        <div class="row">
            <div class="col-sm-4">
                <div>
                    <h2 class="margin-defult">Cuenta</h2>
                </div>
                <div class='account-area'>
                    <p>{{account}}</p>
                </div>
            </div>
            <div class="col-sm-8">
                <div>
                    <div class="row">
                        <div class="col-sm-9">
                            <h2>Mis datos</h2>
                        </div>
                        <div class="col-sm-3 text-right back-button">
                          <button v-if="showLoaderButton" class="edit-button" @click="editAccountInfo()">Guardar Cambios</button>
                          <button v-if="!showLoaderButton" class="edit-button-loader"><img class="loader-input" src="../../public/img/Rolling.gif" alt=""></button>
                            <router-link class="nav-link"  to="/PerfilUsuario">
                                <button class="back-btn-special">
                                    Regresar
                                </button>
                            </router-link>
                        </div>
                    </div>
                    <div class="row row-info">
                        <div class="col-sm-4">
                            <p><strong>Nombre</strong></p> 
                        </div>
                        <div class="col-sm-7">
                            <div v-if="!showLoaderInputs" class="box-loader text-center"><img class="loader-input" src="../../public/img/Rolling-1s-200px.gif" alt=""></div>
                            <input v-if="showLoaderInputs" class="inputs-right" type="text" :placeholder="name" v-model="name">
                        </div>
                    </div>
                    <div class="row row-info">
                        <div class="col-sm-4">
                            <p><strong>Apellido</strong></p> 
                        </div>
                        <div class="col-sm-7">
                            <div v-if="!showLoaderInputs" class="box-loader text-center"><img class="loader-input" src="../../public/img/Rolling-1s-200px.gif" alt=""></div>
                            <input v-if="showLoaderInputs" class="inputs-right" type="text" :placeholder="lastname" v-model="lastname">
                        </div>
                    </div>
                    <div class="row row-info">
                        <div class="col-sm-4">
                            <p><strong>Teléfono</strong></p> 
                        </div>
                        <div class="col-sm-7">
                            <div v-if="!showLoaderInputs" class="box-loader text-center"><img class="loader-input" src="../../public/img/Rolling-1s-200px.gif" alt=""></div>
                            <input v-if="showLoaderInputs" class="inputs-right" type="text" :placeholder="phone" v-model="phone">
                        </div>
                    </div>
                    <div class="row row-info">
                        <div class="col-sm-4">
                            <p><strong>Correo electrónico</strong></p> 
                        </div>
                        <div class="col-sm-7">
                            <div v-if="!showLoaderInputs" class="box-loader text-center"><img class="loader-input" src="../../public/img/Rolling-1s-200px.gif" alt=""></div>
                            <input v-if="showLoaderInputs" class="inputs-right" type="email" :placeholder="email" v-model="email">
                        </div>
                    </div>
                    <div class="row row-info">
                        <div class="col-sm-4">
                            <p><strong>Fecha de nacimineto</strong></p> 
                        </div>
                        <div class="col-sm-7">
                          <div v-if="!showLoaderInputs" class="box-loader text-center"><img class="loader-input" src="../../public/img/Rolling-1s-200px.gif" alt=""></div>
                          <input v-if="showLoaderInputs" class="inputs-right" type="date" :placeholder="bday" v-model="bday">
                        </div>
                    </div>
                    <div class="row row-info">
                        <div class="col-sm-4">
                            <p><strong>Código postal</strong></p> 
                        </div>
                        <div class="col-sm-7">
                            <div v-if="!showLoaderInputs" class="box-loader text-center"><img class="loader-input" src="../../public/img/Rolling-1s-200px.gif" alt=""></div>
                            <input v-if="showLoaderInputs" class="inputs-right" type="text" :placeholder="CP" v-model="CP">
                        </div>
                    </div>
                    <div class="row row-info">
                        <div class="col-sm-4">
                            <p><strong>Sexo</strong></p> 
                        </div>
                        <div class="col-sm-7">
                            <div v-if="!showLoaderInputs" class="box-loader text-center"><img class="loader-input" src="../../public/img/Rolling-1s-200px.gif" alt=""></div>
                            <select v-if="showLoaderInputs" class="inputs-right">
                                <option value="Masculino">Masculino</option>
                                <option value="Femenino">Femenino</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { Card, FormGroupInput, Button } from '@/components';
import {DatePicker} from 'element-ui'
import moment from 'moment';
import ProfileService from '../service/core/profile.service'

export default {
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [DatePicker.name]: DatePicker,

  },
  data(){
    return {
      profileService: new ProfileService(),
      name:'',
      lastname: '',
      phone: '',
      email: '',
      bday: '',
      CP:'',
      sex:'',
      newName: '',
      account:'',
      showLoaderInputs: true,
      showLoaderButton: true
    }
  },
  mounted(){
    this.searchAcountInfo()
  },
  methods:{
    searchAcountInfo(){
        this.showLoaderInputs = false
		this.profileService.account().then(data => {
        this.showLoaderInputs = true
        this.name = data.data.result.nombre
        this.lastname =  data.data.result.apellidos
        this.phone =  data.data.result.cel
        this.email =  data.data.result.email
        this.bday =  data.data.result.fecha_nacimiento
        this.CP = data.data.result.codigo_postal
        this.sex = data.data.result.sexo
        this.account = data.data.result.cuenta
      }, err => {
      
      })
    },
    editAccountInfo(){
      this.showLoaderButton = false
      let condtitons = {
        "account":{
          "email": this.email,
           "cel": this.phone,
           "name": this.name,
           "lastname": this.lastname,
           "zip_code": this.CP,
           "birthday": moment(this.bday).format('YYYY-MM-DD'),
           "gender": 'm'
        }
      }
      this.profileService.editAccount(condtitons).then(data => {
        this.showLoaderButton = true
        this.$notify({
          group: 'foo',
          type: 'success',
          title: '¡Guardado!',
          text: 'Tu información ha sido actualizada.'
        });
      }, err =>{
        this.showLoaderButton = true
        this.$notify({
          group: 'foo',
          type: 'error',
          title: '¡Ups!',
          text: 'Ocurrio un error, por favor verifica tus datos e intentalo de nuevo.'
        });
      })
    }
  }
}
</script>
<style>
.colorA{
    background-color: rgba(165, 42, 42, 0.288);
}
.colorB{
    background-color: rgba(0, 0, 255, 0.24);
}
.more-info-space{
    margin: 10px 0px 10px 10px;
}
.margin-defult{
    margin: 0px;
}
.count-title{
    margin: 0px;
}

.count-info{
    margin: 10px;
}
.QRcode{
    width: 50%;
    margin: 20px;
}
.password-button{
    width: 80%;
    height: 40px;
    color: white;
    margin: 10px;
    font-size: 17px;
    background-color: #006811; 
    border-radius: 21px 21px 21px 21px;
    -moz-border-radius: 21px 21px 21px 21px;
    -webkit-border-radius: 21px 21px 21px 21px;
    border: 0px solid #ffffff;
}
.text-color-blue{
    color: #00bbff;
}
.money-title{
    margin: 5px;
}
.line-border{
    border-bottom: 1px solid #474646d7
}
.icon-title{
    width: 25px;
}
.comer-img{
    width:65%;
    margin: 10px;
}
.borders-defult{
    width: 23%;
    padding: 5px;
    margin: 5px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
}
.cupon-img{
    padding: 30px 5px 30px 5px;
}
.validity-date{
    margin: 0px;
    font-size: 10px;
    padding-left: 140px;
}
.row-info{
    margin: 10px;
}
.inputs{
  width: 80%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.inputs-right{
  width:100%;
  padding: 5px;
  background-color: white;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.inputs-bday{
  width:50%;
  padding: 5px;
  background-color: white;
  border: 1px;
  display: inline-flex;
  border-bottom: 2px solid #ECECEC;
}
.picker-bday{
  display: inline-flex;
  width: 50%;
}
.inputs-title{
    width: 90%;
    margin: 10px 10px -13px 10px;
    font-size: 10px;
}

.back-btn-special{
  width: 100px;
  height: 30px;
  color: #ffffff;
  margin: 10px;
  font-size: 15px;
  background-color: #00bbff; 
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 0px solid #ffffff;
}
.edit-button{
  min-width: 150px;
  background-color: #6b8140;;
  width: 100%;
  height: 30px;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
  border: 0px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
}

.edit-button-loader{
  min-width: 150px;
  background-color: #f0f0f0;
  width: 100%;
  height: 30px;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
  border: 0px;
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
}

.account-area{
  margin-top: 10px;
  padding-left: 100px;
  width:90%;
  border: 1px;
  border-bottom: 2px solid #ECECEC;

}

.loader-input{
    width: 25px;
}
.box-loader{
  padding: 5px;
  background-color: white;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
</style>
